import * as moment from 'moment';
import * as React from 'react';
import DatePicker from 'react-datepicker';
import { Label } from 'reactstrap';
import { TR } from 'src/TextRes';
import './DateRangeInput.css';

interface DateRangeInputProps {
    className?: string;
    onChangeOptionFrom: (value: string) => void;
    onChangeOptionTo: (value: string) => void;
    initializeToToday?: boolean;
    minDate?: moment.Moment;
}

interface DateRangeInputState {
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
}

export default class DateRangeInput extends React.PureComponent<DateRangeInputProps, DateRangeInputState> {
    constructor(props: DateRangeInputProps) {
        super(props);
        const start = props.initializeToToday ? moment(new Date()) : undefined;
        this.state = {
            endDate: undefined,
            startDate: start,
        };
    }

    public render() {
        const classes = ['react-datepicker__narrow'];
        if (this.props.className) {
            classes.push(this.props.className);
        }
        return (
            <div className="rangeRow">
                <Label className="mr-sm-2">{TR.dateRangeInput_from}</Label>
                <DatePicker
                    className={classes.join(' ')}
                    selected={this.state.startDate}
                    placeholderText={'TT.MM.JJJJ'}
                    maxDate={this.state.endDate}
                    minDate={this.props.minDate ? this.props.minDate : undefined}
                    onChange={(e: moment.Moment) => {
                        this.setState({ startDate: e }, () => {
                            let value = '';
                            if (e && e !== undefined && e !== null) {
                                value = moment(e).format('YYYY-MM-DD');
                            }
                            this.props.onChangeOptionFrom(value);
                        });
                    }}
                />
                <Label className="mr-sm-2 ml-sm-3">{TR.dateRangeInput_to}</Label>
                <DatePicker
                    className={classes.join(' ')}
                    selected={this.state.endDate}
                    minDate={this.state.startDate}
                    placeholderText={'TT.MM.JJJJ'}
                    onChange={(e: moment.Moment) => {
                        this.setState({ endDate: e }, () => {
                            let value = '';
                            if (e && e !== undefined && e !== null) {
                                value = moment(e).format('YYYY-MM-DD');
                            }
                            this.props.onChangeOptionTo(value);
                        });
                    }}
                />
            </div>
        );
    }

    public reset() {
        console.log('reset');
        this.setState({ endDate: undefined, startDate: undefined }, () => {
            this.props.onChangeOptionFrom('');
        });
    }
    public reinit() {
        console.log('reinit');
        const startStr = moment(new Date()).format('YYYY-MM-DD');
        this.setState({ endDate: undefined, startDate: moment(new Date()) }, () => {
            this.props.onChangeOptionFrom(startStr);
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/dateRangeInput/DateRangeInput.tsx